import React, { useCallback, useState, useEffect } from "react";
import {
  DropZone,
  Page,
  FormLayout,
  TextField,
  Card,
  Spinner,
  Toast,
  Button,
  Text,
  Loading,
  Checkbox,
  Select,
  Stack,
  Thumbnail,
} from "@shopify/polaris";
// import axios from "axios";
import axios from "../Assets/Lib/axios";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LineChart,
  Line,
  ResponsiveContainer,
  PieChart,
  Pie,
  AreaChart,
  Area,
} from "recharts";
import "react-dynamic-charts/dist/index.css";
import visitorsImg from "../Assets/Images/visitors.svg";
import sessionsImg from "../Assets/Images/sessions.svg";
import pageViewsImg from "../Assets/Images/page-views.svg";
import sessionsAverageImg from "../Assets/Images/sessions-average.svg";
import HSBar from "react-horizontal-stacked-bar-chart";
import moment from "moment";
import { accessDashboard } from "../Helpers";

const Dashboard = () => {
  const [isLoading, setIsLoading] = useState(true);
  var randomColor = require("randomcolor");
  const [result, setResult] = useState({
    visitors: 0,
    sessions: 0,
    sessionsAverage: 0,
    pageViews: 0,
    sessionsByDay: [],
    pageViewsByCountry: [],
    pageViewsByBrowser: [],
    sessionsByCountry: [],
  });
  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    Promise.all([
      axios.get(`/analytics?metrics=newUsers`),
      axios.get(`/analytics?metrics=sessions`),
      axios.get(`/analytics?metrics=averageSessionDuration`),
      axios.get(`/analytics?metrics=screenPageViews`),
      axios.get(`/analytics?metrics=sessions&dimensions=date&period=7`),
      axios.get(
        `/analytics?metrics=screenPageViews&dimensions=country&limit=3`
      ),
      axios.get(`/analytics?metrics=sessions&dimensions=country&limit=10`),
      axios.get(
        `/analytics?metrics=screenPageViews&dimensions=browser&limit=3`
      ),
    ])
      .then(function (responses) {
        //setPopupActive(false);

        const responseVisitors = responses[0];
        const responseSessions = responses[1];
        const responseSessionsAverage = responses[2];
        const responsePageViews = responses[3];
        const responseSessionsByDay = responses[4];
        const responsePageViewsByCountry = responses[5];
        const responseSessionsByCountry = responses[6];
        const responsePageViewsByBrowser = responses[7];
        setResult({
          ...result,
          visitors: responseVisitors?.data?.data?.analytics?.length
            ? responseVisitors.data.data.analytics[0].newUsers
            : 0,
          sessions: responseSessions?.data?.data?.analytics?.length
            ? responseSessions.data.data.analytics[0].sessions
            : 0,
          sessionsAverage: responseSessionsAverage?.data?.data?.analytics
            ?.length
            ? Math.round(
                responseSessionsAverage.data.data.analytics[0]
                  .averageSessionDuration
              )
            : 0,
          pageViews: responsePageViews?.data?.data?.analytics?.length
            ? responsePageViews.data.data.analytics[0].screenPageViews
            : 0,
          sessionsByDay: responseSessionsByDay?.data?.data?.analytics?.length
            ? responseSessionsByDay.data.data.analytics.map((item) => ({
                name: moment(item.date).format("YYYY-MM-DD"),
                numberSessions: item.sessions,
                // amt: item[1],
              }))
            : [],
          sessionsByCountry: responseSessionsByCountry?.data?.data?.analytics
            ?.length
            ? responseSessionsByCountry.data.data.analytics.map((item) => ({
                value: parseInt(item.sessions),
                name: item.country,
                // amt: item[1],
              }))
            : [],
          pageViewsByCountry: responsePageViewsByCountry?.data?.data?.analytics
            ?.length
            ? responsePageViewsByCountry.data.data.analytics.map((item) => ({
                name: item.country,
                value: item.screenPageViews,
              }))
            : [],
          pageViewsByBrowser: responsePageViewsByBrowser?.data?.data?.analytics
            ?.length
            ? responsePageViewsByBrowser.data.data.analytics.map((item) => ({
                name: item.browser,
                numberPageViews: item.screenPageViews,
              }))
            : [],
        });
        setIsLoading(false);
      })
      .catch(function (err) {
        setIsLoading(false);
      });
  }

  return (
    accessDashboard() && (
      <Page title="Dashboard" fullWidth>
        {isLoading ? <Loading /> : null}
        {/* <h1>{JSON.stringify(result)}</h1> */}
        {!isLoading ? (
          <FormLayout>
            <FormLayout.Group condensed>
              <Card
                sectioned
                title={
                  <div className="rowDiv">
                    <img src={visitorsImg} width={40} className="me-2"></img>
                    <div className="mt-2">
                      <Text variant="headingMd" as="h6">
                        Visitors
                      </Text>
                    </div>
                  </div>
                }
              >
                <Text variant="heading3xl" as="h2">
                  {result.visitors}
                </Text>
              </Card>
              <Card
                sectioned
                title={
                  <div className="rowDiv">
                    <img src={sessionsImg} width={40} className="me-2"></img>

                    <div className="mt-2">
                      <Text variant="headingMd" as="h6">
                        Sessions
                      </Text>
                    </div>
                  </div>
                }
              >
                <Text variant="heading3xl" as="h2">
                  {result.sessions}
                </Text>
              </Card>
              <Card
                sectioned
                title={
                  <div className="rowDiv">
                    <img
                      src={sessionsAverageImg}
                      width={40}
                      className="me-2"
                    ></img>
                    <div className="mt-2">
                      <Text variant="headingMd" as="h6">
                        Sessions Average
                      </Text>
                    </div>
                  </div>
                }
              >
                <Text variant="heading3xl" as="h2">
                  {result.sessionsAverage}
                </Text>
              </Card>
              <Card
                sectioned
                title={
                  <div className="rowDiv">
                    <img src={pageViewsImg} width={40} className="me-2"></img>
                    <div className="mt-2">
                      <Text variant="headingMd" as="h6">
                        Page Views
                      </Text>
                    </div>
                  </div>
                }
              >
                <Text variant="heading3xl" as="h2">
                  {result.pageViews}
                </Text>
              </Card>
            </FormLayout.Group>
            <FormLayout.Group>
              <Card title="Sessions ( Last 7 Days )" sectioned>
                <ResponsiveContainer width="100%" height={400}>
                  <BarChart
                    // width={400}
                    // height={300}
                    data={result.sessionsByDay}
                    margin={{ top: 5, right: 31, left: 0, bottom: 5 }}
                    options={{
                      maxBarThickness: 4,
                      scales: {
                        xAxes: [
                          {
                            barPercentage: 0.2,
                          },
                        ],
                      },
                    }}
                  >
                    <CartesianGrid strokeDasharray="1 1" opacity={0.5} />
                    <XAxis dataKey="name" />
                    <YAxis />
                    {/* <Tooltip /> */}
                    {/* <Legend /> */}
                    <Bar dataKey="numberSessions" fill="#0094FE" />
                  </BarChart>
                </ResponsiveContainer>

                {/* <LiveBarChart data={dataTest} /> */}
                {/* <Chart data={data} axes={axes} /> */}
              </Card>
              <Card title="Sessions by country ( Top 10 )" sectioned>
                <ResponsiveContainer width="100%" height={400}>
                  <AreaChart
                    width={600}
                    height={600}
                    data={result.sessionsByCountry}
                    margin={{
                      top: 10,
                      right: 30,
                      left: 0,
                      bottom: 0,
                    }}
                  >
                    <CartesianGrid strokeDasharray="1 1" opacity={0.5} />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Area
                      type="monotone"
                      dataKey="value"
                      stroke="#00E097"
                      fill="#00E097"
                    />
                  </AreaChart>

                  {/* <PieChart width={600} height={600}>
                    <Pie
                      dataKey="value"
                      data={result.sessionsByCountry}
                      // outerRadius={80}
                      fill="#00E097"
                      label={({
                        cx,
                        cy,
                        midAngle,
                        innerRadius,
                        outerRadius,
                        value,
                        index,
                      }) => {
                        console.log("handling label?");
                        const RADIAN = Math.PI / 180;
                        // eslint-disable-next-line
                        const radius =
                          25 + innerRadius + (outerRadius - innerRadius);
                        // eslint-disable-next-line
                        const x = cx + radius * Math.cos(-midAngle * RADIAN);
                        // eslint-disable-next-line
                        const y = cy + radius * Math.sin(-midAngle * RADIAN);

                        return (
                          <text
                            x={x}
                            y={y}
                            fill="#00E097"
                            textAnchor={x > cx ? "start" : "end"}
                            dominantBaseline="central"
                          >
                            {result.sessionsByCountry[index].name} ({value})
                          </text>
                        );
                      }}
                    />
                  </PieChart> */}
                </ResponsiveContainer>
              </Card>
              {/* <Card title="Sessions by country ( Top 10 )" sectioned>
              <ResponsiveContainer width="100%" height={400}>
                <BarChart
                
                  data={result.sessionsByCountry}
                  margin={{ top: 5, right: 31, left: 20, bottom: 5 }}
                >
                  <CartesianGrid strokeDasharray="1 1" opacity={0.5} />
                  <XAxis dataKey="name" />
                  <YAxis />
                 
                  <Bar dataKey="sessions" fill="#00E097" />
                </BarChart>
              </ResponsiveContainer>
             
            </Card> */}
            </FormLayout.Group>

            {/* <Card title="Pageviews by country ( Top 3 )" sectioned>
            <HSBar
              height={50}
              showTextIn
              //showTextUp
              // showTextDown
              id="new_id"
              fontColor="rgb(50,20,100)"
              data={result.pageViewsByCountry}
            />
          </Card> */}
            <FormLayout.Group>
              <Card title="Pageviews by country ( Top 3 )" sectioned>
                <ResponsiveContainer width="100%" height={400}>
                  <AreaChart
                    width={600}
                    height={600}
                    data={result.pageViewsByCountry}
                    margin={{ top: 5, right: 31, left: 0, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="1 1" opacity={0.5} />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Area
                      type="monotone"
                      dataKey="value"
                      stroke="#EC407A"
                      fill="#EC407A"
                    />
                  </AreaChart>
                  {/* <LineChart
                  
                    data={result.pageViewsByCountry}
                    margin={{ top: 5, right: 31, left: 0, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="1 1" opacity={0.5} />
                    <XAxis dataKey="name" />
                    <YAxis />
                   
                    <Line dataKey="numberPageViews" stroke="#EC407A" />
                  </LineChart> */}
                </ResponsiveContainer>

                {/* <LiveBarChart data={dataTest} /> */}
                {/* <Chart data={data} axes={axes} /> */}
              </Card>
              <Card title="Pageviews by browser ( Top 3 )" sectioned>
                <ResponsiveContainer width="100%" height={400}>
                  <LineChart
                    data={result.pageViewsByBrowser}
                    margin={{ top: 5, right: 31, left: 0, bottom: 5 }}
                  >
                    <CartesianGrid strokeDasharray="1 1" opacity={0.5} />
                    <XAxis dataKey="name" />
                    <YAxis />

                    <Line dataKey="numberPageViews" stroke="#AB47BC" />
                  </LineChart>
                </ResponsiveContainer>

                {/* <LiveBarChart data={dataTest} /> */}
                {/* <Chart data={data} axes={axes} /> */}
              </Card>
            </FormLayout.Group>
          </FormLayout>
        ) : (
          <div className="spinnerContainer">
            <div className="vertical-center">
              <Spinner size="large" />
            </div>
          </div>
        )}
      </Page>
    )
  );
};

export default Dashboard;
